import { projectStore } from '../storage/storage';
import { IAction } from '../entities/IAction';

/**
 * 创建动作处理器
 * @param createDefaultAction 创建默认动作的函数（V2 格式）
 * @returns onSelect 处理函数
 */
export function createActionHandler(
  createDefaultAction: () => any
) {
  return function onSelect({query}: {query: any}) {
    // 1. 从 Store 中通过 ULID 查找 ActionGroup
    const actionGroup = projectStore.actionGroupMap?.[query.actionGroupUlid];
    if (!actionGroup) {
      throw new Error(`ActionGroup not found: ${query.actionGroupUlid}`);
    }

    // 2. 创建默认动作（V2 格式）
    const action = createDefaultAction() as IAction;

    // 3. 修改：只维护children（存储完整对象），list由后端维护
    if (!actionGroup.children) {
      actionGroup.children = [];
    }
    actionGroup.children.push(action);

    // 4. 注册到 Store（供后续查找使用）
    projectStore.actionMap[action.ulid] = action;

    // 6. 返回编辑页面
    window.history.back();
  };
}
